export enum Blockchain {
  ETHEREUM = "ethereum",
  BASE = "base",
}

export const PERSONA_NFT_COUNT = 8888;
